import { Icon } from '@/lib/icons';
import { useApp } from '@/hooks/use-app-context';

export function AccessDenied() {
  const { t } = useApp();

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <div className="w-full max-w-lg">
        <div className="relative py-8 text-center">
          <p className="flex items-center justify-center gap-3 text-[0.68rem] font-semibold uppercase tracking-[0.28em] text-brand">
            403
          </p>
          <h1 data-testid="access-denied" className="mt-4 text-4xl font-semibold tracking-tight text-foreground">
            {t.accessDeniedTitle}
          </h1>
          <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300/[0.76]">
            {t.accessDeniedGeneric}
          </p>
        </div>

        <div className="flex justify-center pt-6">
          <a
            href="/"
            className="inline-flex items-center gap-2 rounded-full border border-brand/20 bg-brand px-5 py-2.5 text-sm font-semibold text-slate-950 transition-colors hover:bg-brand"
          >
            <Icon name="arrowLeft" className="h-4 w-4" />
            {t.backToHomeCta}
          </a>
        </div>
      </div>
    </div>
  );
}
